import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import AdminLayout from "../../layouts/AdminLayout";
import {
  Timestamp,
  addDoc,
  collection,
  getDocs,
} from "firebase/firestore";
import { fireDb } from "../../firebase";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default function AddPost() {
  const [catgs, setCatgs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [coverImageUploading, setCoverImageUploading] = useState(false);
  const [allowImg, setAllowImg] = useState(true);

  const [uploadedImageUrl, setUploadedImageUrl] = useState("");

  const [formData, setFormData] = useState({
    id: "",
    title: "",
    cialt: "",
    content: "",
    coverimages: "",
    blogfor: "",
    categoryname: [],
    description: "",
    slug: "",
  });

  const [editorHtml, setEditorHtml] = useState("");

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploadedImageUrl("");
    setCoverImageUploading(true);

    const payload = new FormData();
    // The API expects the field key to be 'file', not 'image'
    payload.append("file", file);

    // Retrieve token from storage, context, or auth state
    const token = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX3Bob25lIjoiNzk4OTAzMDc0MSIsImFsdGVybmF0ZV9waG9uZSI6IiIsImlzX2NpdHlfbWFuYWdlciI6ZmFsc2UsImJyYW5jaF9jYXJfb3duZXIiOmZhbHNlLCJhbGxfY2Fyc19pbmZvIjpmYWxzZX0.51tF-4cEb0mDXY94Ow7f_NRKu5hmcTA_sUK3bPQd7hc"

    try {
      const response = await fetch("/l-s3-dc/image-file", {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: payload,
      });

      if (!response.ok) {
        throw new Error(`Upload failed with status: ${response.status}`);
      }

      const result = await response.json();

      // Check against the API response format: result.status === "success"
      if (result?.status === "success" && result?.data?.image_link) {
        setUploadedImageUrl(result.data.image_link);
      } else {
        console.error("Upload error response:", result?.message || "Unknown error");
      }
    } catch (err) {
      console.error("Error uploading image:", err);
    } finally {
      setCoverImageUploading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "categoryname") {
      const selectedCategories = Array.from(
        e.target.selectedOptions,
        (option) => option.value
      );
      setFormData((prev) => ({
        ...prev,
        categoryname: selectedCategories,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const calculateReadTime = (text) => {
    const words = text.split(/\s+/).filter((w) => w.length > 0);
    const wordCount = words.length;
    const wordsPerMinute = 183;
    if (wordCount === 0) return 0;
    return Math.ceil(wordCount / wordsPerMinute);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newPost = {
      title: formData.title,
      description: formData.description,
      slug: formData.slug.replaceAll(" ", "-").toLowerCase().replace(/[;,]/g, ""),
      content: editorHtml,
      coverimages: uploadedImageUrl,
      blogfor: formData.blogfor,
      categoryname: formData.categoryname,
      createdAt: new Date().toISOString(),
      cialt: formData.cialt,
      timetake: calculateReadTime(editorHtml),
      blog_state: "in-progress",
    };

    try {
      setLoading(true);
      const blogRef = collection(fireDb, "blogPost");
      await addDoc(blogRef, {
        ...newPost,
        time: Timestamp.now(),
        postauthor: localStorage.getItem("AdminName"),
        date: new Date().toLocaleString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        }),
      });

      Swal.fire({
        icon: "success",
        title: "Post Created",
        html: `Title: ${formData.title}`,
      });

      setFormData({
        id: "",
        title: "",
        description: "",
        content: "",
        coverimages: "",
        blogfor: "",
        categoryname: [],
        cialt: "",
        slug: "",
      });
      setEditorHtml("");
      setUploadedImageUrl("");
      setLoading(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "There was an issue creating the post. Please try again.",
      });
    }
  };

  const handleClear = () => {
    setFormData({
      id: "",
      title: "",
      description: "",
      content: "",
      coverimages: "",
      blogfor: "",
      categoryname: [],
      cialt: "",
      slug: "",
    });
    setEditorHtml("");
  };

  useEffect(() => {
    if (formData.blogfor === "Dozzy" || formData.blogfor === "LDC") {
      setAllowImg(false);
    } else {
      setAllowImg(true);
    }
  }, [formData.blogfor]);

  useEffect(() => {
    const fetchCatgs = async () => {
      const colName =
        formData.blogfor === "LDC"
          ? "catgforldc"
          : formData.blogfor === "Dozzy"
            ? "catgfordozzy"
            : formData.blogfor === "DozzyBng"
              ? "catgfordozzybng"
              : formData.blogfor === "zuget"
                ? "catgforzuget"
                : formData.blogfor === "crocto"
                  ? "catgforcrocto"
                  : formData.blogfor === "ldcattachments"
                    ? "catgforldcattachments"
                    : "none";

      if (colName === "none") {
        setCatgs([]);
        return;
      }

      const querySnapshot = await getDocs(collection(fireDb, colName));
      const cats = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCatgs(cats);
    };

    fetchCatgs();
  }, [formData.blogfor]);

  // Custom upload adapter for CKEditor
  function CustomUploadAdapter(loader) {
    return {
      upload() {
        return loader.file.then(
          (file) =>
            new Promise((resolve, reject) => {
              // Validate file type
              if (file.type !== "image/webp") {
                reject("Please upload a .webp image.");
                alert("Please upload a .webp image.");
                return;
              }

              const data = new FormData();
              data.append("image", file);
              data.append("blogfor", formData.blogfor);

              axios
                .post("https://reactadminblog.vercel.app/api/uploadei", data, {
                  headers: { "Content-Type": "multipart/form-data" },
                })
                .then((res) => {
                  if (res.data.success) {
                    resolve({
                      default: res.data.imageUrl,
                    });
                  } else {
                    reject("Upload failed");
                    alert("Upload failed");
                  }
                })
                .catch((err) => {
                  console.error("Upload error", err);
                  reject(err);
                });
            })
        );
      },
      abort() {
        // Handle abort if needed
      },
    };
  }

  function CustomUploadAdapterPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return CustomUploadAdapter(loader);
    };
  }

  return (
    <AdminLayout>
      <div
        style={{ width: "900px" }}
        className="shadow-md flex-row px-1 mt-5 items-center pt-2 pb-2 mb-2 justify-center rounded-lg ml-10 bg-white"
      >
        <h2 className="text-2xl font-semibold mb-4 text-center hover:text-indigo-500">
          Add New Post
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4 w-full p-1">
          <div className="flex flex-col pt-4">
            <label htmlFor="blogfor" className="text-lg">
              Blog For
            </label>
            <select
              id="blogfor"
              name="blogfor"
              value={formData.blogfor}
              onChange={handleChange}
              className="border rounded-lg p-2"
            >
              <option value="none">select from below</option>
              <option value="LDC">LDC</option>
              <option value="Dozzy">Dozzy</option>
              <option value="DozzyBng">Dozzy Bangalore</option>
              <option value="zuget">Zuget</option>
              <option value="crocto">Crocto</option>
              <option value="ldcattachments">LDC - Attachments</option>
            </select>
          </div>

          <div className="flex flex-col pt-4">
            <label htmlFor="categoryname" className="text-lg">
              Category
            </label>
            <select
              id="categoryname"
              name="categoryname"
              value={formData.categoryname}
              onChange={handleChange}
              multiple
              className="border rounded-lg p-2"
            >
              {catgs.map((cat) => (
                <option key={cat.id} value={cat.name}>
                  {cat.name}
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-col pt-4">
            <label htmlFor="title" className="text-lg">
              Title
            </label>
            <input
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              className="border rounded-lg p-2"
              required
            />
          </div>
          <div className="flex flex-col pt-4">
            <label htmlFor="description" className="text-lg">
              Description (Meta)
            </label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows="3"
              className="border rounded-lg p-2"
            />
          </div>
          <div className="flex gap-4 pt-4">
            <div className="flex flex-col">
              <label htmlFor="coverimages" className="text-lg">
                Cover Image
              </label>
              <input
                type="file"
                id="coverimages"
                name="coverimages"
                accept="image/*"
                onChange={handleImageUpload}
                className="border rounded-lg p-2"
                disabled={allowImg || coverImageUploading}
              />
              {coverImageUploading && (
                <div className="mt-2 flex items-center gap-2 text-sm text-indigo-600">
                  <span className="h-4 w-4 animate-spin rounded-full border-2 border-indigo-200 border-t-indigo-600" />
                  Uploading cover image...
                </div>
              )}
              {uploadedImageUrl.length ? <img
                src={uploadedImageUrl} // Adjust URL for public access
                alt="Cover Preview"
                className="w-32 h-32 object-cover rounded"
              /> : <p className="p-1 pt-4 text-red-500">No img uploaded</p>}
              {/* {console.log(uploadedImageUrl, "uploadedImageUrl")} */}
            </div>
            <div className="flex flex-col">
              <label htmlFor="cialt" className="text-lg">
                Cover image Alt text{" "}
              </label>
              <input
                type="text"
                id="cialt"
                name="cialt"
                value={formData.cialt}
                onChange={handleChange}
                required
                className="border rounded-lg p-2"
              />
            </div>
          </div>
          {/* <div className="flex flex-col pt-4">
            <label htmlFor="cialt" className="text-lg">
              Cover Image ALT Text
            </label>
            <input
              id="cialt"
              name="cialt"
              value={formData.cialt}
              onChange={handleChange}
              className="border rounded-lg p-2"
            />
          </div> */}

          {allowImg && (
            <div className="flex flex-col pt-4">
              <label htmlFor="coverimages" className="text-lg">
                Upload Cover Image (.webp only)
              </label>
              <input
                type="file"
                id="coverimages"
                name="coverimages"
                accept=".webp"
                onChange={handleImageUpload}
                className="border rounded-lg p-2"
              />
              {uploadedImageUrl && (
                <img
                  src={uploadedImageUrl}
                  alt="Cover Preview"
                  className="w-40 mt-2"
                />
              )}
            </div>
          )}

          <div className="flex flex-col pt-4">
            <label htmlFor="slug" className="text-lg">
              Slug
            </label>
            <input
              id="slug"
              name="slug"
              value={formData.slug}
              onChange={handleChange}
              className="border rounded-lg p-2"
              required
            />
          </div>


          <div className="flex flex-col pt-4">
            <label className="text-lg">Content</label>
            <div className="custom-editor pl-">
              <CKEditor
                editor={ClassicEditor}
                data={editorHtml}
                config={{
                  extraPlugins: [CustomUploadAdapterPlugin],
                  toolbar: [
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "underline",
                    "strikethrough",
                    "link",
                    "bulletedList",
                    "numberedList",
                    "|",
                    "alignment",
                    "outdent",
                    "indent",
                    "|",
                    "blockQuote",
                    "insertTable",
                    "tableColumn",
                    "tableRow",
                    "mergeTableCells",
                    "|",
                    "imageUpload", // ✅ Add this
                    "undo",
                    "redo",
                    "|",
                    "fontColor",
                    "fontBackgroundColor",
                  ],
                  image: {
                    toolbar: [
                      'imageTextAlternative',
                      'imageStyle:full',
                      'imageStyle:side'
                    ]
                  },
                  table: {
                    contentToolbar: [
                      "tableColumn",
                      "tableRow",
                      "mergeTableCells",
                      "tableProperties",
                      "tableCellProperties",
                    ],
                  },
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setEditorHtml(data);
                }}
              />

            </div>

          </div>



          <div className="flex justify-between pt-6">
            <button
              type="submit"
              className="bg-indigo-600 text-white px-6 py-2 rounded hover:bg-indigo-700"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>

            <button
              type="button"
              onClick={handleClear}
              className="bg-gray-400 text-white px-6 py-2 rounded hover:bg-gray-500"
            >
              Clear
            </button>
          </div>
        </form>
      </div>
    </AdminLayout>
  );
}
